import {useApi} from "../Api";
import {RateDetail, RateDetailCopyRequest} from "../types/rateDetail";
import axios from "axios";
import dayjs from "dayjs";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {SET_SNACKBAR} from "../../constants";
import React from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";

export const useRateDetailRepository = () => {
    const {GET, POST, PUT} = useApi();

    const {dispatchGlobalData} = React.useContext(GlobalContext);

    const PATH = "/pricing/rate-detail";

    function getRateDetails(rateId: number): Promise<RateDetail[]> {
        return GET(`${PATH}/price-matrix?rateId=${rateId}`);
    }

    function getRateDetailsFromCopyRate(body: RateDetailCopyRequest): Promise<RateDetail[]> {
        return POST(`${PATH}/copy-price-matrix`, body);
    }

    function getRateDetailsFromExcelFile({
                                             rateId,
                                             excelFile
                                         }: { rateId: number, excelFile: File }): Promise<RateDetail[]> {
        let formData = new FormData();
        formData.append("xlsFile", excelFile);

        return POST(`${PATH}/import-price-matrix?rateId=${rateId}`, formData, {headers: {"Content-Type": "multipart/form-data"}}, true);
    }

    function persistRateDetails({
                                    rateId,
                                    rateDetails
                                }: { rateId: number, rateDetails: RateDetail[] }): Promise<RateDetail[]> {
        return PUT(`${PATH}/update-price-matrix`, {rateId, rateDetails});
    }

    function deleteRateDetails(rateDetailIds: number[]): Promise<number[]> {
        return POST(`${PATH}/full-delete`, rateDetailIds);
    }

    function exportJimpyRateExcel(props: any): Promise<void> {
        return axios.get(`${PATH}/export?rateId=${props.id}`, {
            headers: {
                'Content-type': 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet'
            },
            responseType: 'blob',
        })
            .then(({data}) => {
                const blob = new Blob([data], {
                    type: `application/${'vnd.openxmlformatsofficedocument.spreadsheetml.sheet'}`,
                });

                const url = window.URL.createObjectURL(blob); // creiamo l'url al Blob
                const a = document.createElement('a'); // creiamo un elemento nel DOM
                const title = `export_rate_Jimpy_${dayjs().format("YYYYMMDDHHmm")}_${props.id}.xlsx`; // creiamo il titolo per il file

                a.href = url; // appendiamo l'url del Blob all'elemento creato
                a.download = `${title}`; // appendiamo la proprietà di download con nome ed estension del file
                a.click(); // aggiungiamo il click event per procedere al download

            })

            .catch(async error => {

                let parsedError = JSON.parse(await error.response.data.text())
                let parsed = JSON.parse(await parsedError.errorDetails)
                if (await parsed) {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: parsed.reportedErrors,
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                } else {
                    dispatchGlobalData(SET_SNACKBAR.ERROR);
                }
                return Promise.reject(error);
            })
    }

    function exportRateExcel(rateId: number, legalEntity: string): Promise<void> {
        return axios.get(`${PATH}/export/net-rate?rateId=${rateId}&legalEntities=${legalEntity}`, {
            headers: {
                'Content-type': 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet'
            },
            responseType: 'blob',
        })
            .then(({data}) => {
                const blob = new Blob([data], {
                    type: `application/${'vnd.openxmlformatsofficedocument.spreadsheetml.sheet'}`,
                });

                const url = window.URL.createObjectURL(blob); // creiamo l'url al Blob
                const a = document.createElement('a'); // creiamo un elemento nel DOM
                const title = `export_rate_${dayjs().format("YYYYMMDDHHmm")}_${rateId}.xlsx`; // creiamo il titolo per il file

                a.href = url; // appendiamo l'url del Blob all'elemento creato
                a.download = `${title}`; // appendiamo la proprietà di download con nome ed estension del file
                a.click(); // aggiungiamo il click event per procedere al download

            })

            .catch(async error => {

                let parsedError = JSON.parse(await error.response.data.text())
                let parsed = JSON.parse(await parsedError.errorDetails)
                if (await parsed) {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: parsed.reportedErrors,
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                } else {
                    dispatchGlobalData(SET_SNACKBAR.ERROR);
                }
                return Promise.reject(error);
            })
    }

    function exportRateExcelProductCode(rateId: number, productCode: string, legalEntity: string): Promise<void> {
        return axios.get(`${PATH}/export/net-rate?rateId=${rateId}&productCode=${productCode}&legalEntities=${legalEntity}`, {
            headers: {
                'Content-type': 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet'
            },
            responseType: 'blob',
        })
            .then(({data}) => {
                const blob = new Blob([data], {
                    type: `application/${'vnd.openxmlformatsofficedocument.spreadsheetml.sheet'}`,
                });

                const url = window.URL.createObjectURL(blob); // creiamo l'url al Blob
                const a = document.createElement('a'); // creiamo un elemento nel DOM
                const title = `export_rate_${dayjs().format("YYYYMMDDHHmm")}_${rateId}.xlsx`; // creiamo il titolo per il file

                a.href = url; // appendiamo l'url del Blob all'elemento creato
                a.download = `${title}`; // appendiamo la proprietà di download con nome ed estension del file
                a.click(); // aggiungiamo il click event per procedere al download

            })

            .catch(async error => {

                let parsedError = JSON.parse(await error.response.data.text())
                let parsed = JSON.parse(await parsedError.errorDetails)
                if (await parsed) {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: parsed.reportedErrors,
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                } else {
                    dispatchGlobalData(SET_SNACKBAR.ERROR);
                }
                return Promise.reject(error);
            })
    }

    return {
        getRateDetails,
        getRateDetailsFromCopyRate,
        getRateDetailsFromExcelFile,
        persistRateDetails,
        deleteRateDetails,
        exportJimpyRateExcel,
        exportRateExcel,
        exportRateExcelProductCode
    };
};